import React, { useState, useEffect } from "react";
import { Button } from "reactstrap";
import { useHistory } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { getSchema } from "./validation";
import LoadingScreen from "react-loading-screen";
import logo from "../../../../../assets/img/logo/logo_aig_login-2.png";

import DatosClienteSection from "./DatosClienteSection";
import LineaNegocioSection from "./LineasNegocioSection";
import PolizasVigentesSection from "./PolizasVigentesSection";

import CrearCompromisoLayout from "../../../components/CrearCompromisoLayout";
import MessageDialog from "../../../../../components/Compras/MessageDialog";

import {
    setDatosNuevoCompromiso,
    guardarCompromiso,
    validarDuplicidadCompromiso,
    consultarPolizasVigentes
} from "../../../redux/aCompromisos";

import {
    selectNuevoCompromiso,
    selectGuardarCompromisoLoading
} from "../../../redux/selectors";


const LineasNegocio = () => {
    const dispatch = useDispatch();
    const history = useHistory();

    const datosUsuario = useSelector((state) => state.datosUsuarios.dataUsuario);
    const nuevoCompromiso = useSelector(selectNuevoCompromiso);

    const guardarCompromisoLoading = useSelector(selectGuardarCompromisoLoading);
    const tipoIdentificacion = nuevoCompromiso.tipoIdentificacion || "";
    const numeroIdentificacion = nuevoCompromiso.numeroIdentificacion || "";
    const [nombreCompleto, setNombreCompleto] = useState(nuevoCompromiso.nombreCompleto || "");
    const [emailCliente, setEmailCliente] = useState(nuevoCompromiso.emailCliente || "");
    const [telefono, setTelefono] = useState(nuevoCompromiso.telefono || "");
    const [celular, setCelular] = useState(nuevoCompromiso.celular || "");
    const lineasNegocio = nuevoCompromiso.lineasNegocio || [];
    const polizasVigentes = nuevoCompromiso.polizasVigentes || [];
    const sucursal = nuevoCompromiso.sucursal || null;

    const [errores, setErrores] = useState({});
    const [errorLineas, setErrorLineas] = useState("");

    const [mostrarDuplicidad, setMostrarDuplicidad] = useState(false);
    const [mensajeDuplicidad, setMensajeDuplicidad] = useState("");

    const [ramoConsulta, setRamoConsulta] = useState(null);
    const [consultandoPolizas, setConsultandoPolizas] = useState(false);
    const [errorPolizas, setErrorPolizas] = useState("");

    const codigosRamosConsulta = [
        ...new Set(
            [
                ...lineasNegocio.map(
                    (item) => Number(item.rmCodigo)
                ),
                ramoConsulta
                    ? Number(ramoConsulta.rmCodigo)
                    : null
            ].filter(
                (codigo) =>
                    Number.isFinite(codigo) &&
                    codigo > 0
            )
        )
    ].sort((a, b) => a - b);

    const claveRamosConsulta = codigosRamosConsulta.join(",");

    const handleAnterior = () => {
        dispatch(
            setDatosNuevoCompromiso({
                nombreCompleto,
                emailCliente,
                telefono,
                celular,
                lineasNegocio,
                polizasVigentes,
                sucursal
            })
        );
        history.push("/compromisos/crear");
    };

    const handleSiguiente = async () => {
        console.log("gola");
        const datosPantalla2 = {
            nombreCompleto,
            emailCliente,
            telefono,
            celular,
            sucursal
        };

        console.log("datosPantalla2", datosPantalla2);

        try {

            await getSchema().validate(
                datosPantalla2,
                {
                    abortEarly: false
                }
            );

            setErrores({});

            if (!lineasNegocio.length) {

                setErrorLineas(
                    "Debe agregar al menos una línea de negocio"
                );

                return;
            }

            setErrorLineas("");

            const codigosRamos = lineasNegocio.map(
                (item) => Number(item.rmCodigo)
            );

            const respuestaDuplicidad = await dispatch(
                validarDuplicidadCompromiso(
                    numeroIdentificacion,
                    codigosRamos,
                    nuevoCompromiso.idCompromiso
                )
            );

            if (
                respuestaDuplicidad.success &&
                respuestaDuplicidad.data.duplicado
            ) {
                const mensajeDuplicidad =
                    respuestaDuplicidad.data &&
                        respuestaDuplicidad.data.message
                        ? respuestaDuplicidad.data.message
                        : "Ya existe un compromiso activo para este cliente con uno o más de los ramos seleccionados.";

                setMensajeDuplicidad(mensajeDuplicidad);

                setMostrarDuplicidad(true);

                return;
            }

            const lineasGuardar =
                nuevoCompromiso.lineasNegocio.map((item) => ({
                    lnCodigo: Number(item.lnCodigo),
                    rmCodigo: Number(item.rmCodigo)
                }));

            const datosGuardar = {

                brokerSolicitante: nuevoCompromiso.brokerSolicitante,
                emailAsesor: nuevoCompromiso.emailAsesor,
                codigoCoreAsesor: datosUsuario.cliCodigoCore,
                rolAsesor: datosUsuario.usu_tipo_usuario,
                brokerCodigo: datosUsuario.brokerCodigo,
                brokerNombre: datosUsuario.brokerNombre,
                brokerRUC: datosUsuario.brokerRUC,
                tipoIdentificacion: nuevoCompromiso.tipoIdentificacion,
                numeroIdentificacion: nuevoCompromiso.numeroIdentificacion,
                nombreCompleto,
                emailCliente,
                telefono,
                celular,
                sucursal,
                stupendo: nuevoCompromiso.stupendo || false,
                dataTitular: nuevoCompromiso.dataTitular || [],
                lineasNegocio: lineasGuardar,
                pasoActual: 3
            };

            const respuesta = await dispatch(
                guardarCompromiso(datosGuardar)
            );

            if (!respuesta.success) {
                return;
            }

            dispatch(
                setDatosNuevoCompromiso({
                    ...datosPantalla2,

                    lineasNegocio:
                        lineasNegocio.map(
                            (item) => ({
                                ...item,
                                persistido: true
                            })
                        ),

                    idCompromiso:
                        respuesta.idCompromiso,

                    pasoActual: 3
                })
            );

            history.push(
                "/compromisos/crear/datos-negocio"
            );

        } catch (error) {

            const erroresFormulario = {};

            if (error.inner) {

                error.inner.forEach((item) => {

                    if (!erroresFormulario[item.path]) {
                        erroresFormulario[item.path] =
                            item.message;
                    }

                });

                setErrores(erroresFormulario);
            }
        }

    };

    useEffect(() => {
        let cancelado = false;

        const consultar = async () => {

            if (
                !numeroIdentificacion ||
                !claveRamosConsulta
            ) {
                dispatch(
                    setDatosNuevoCompromiso({
                        polizasVigentes: []
                    })
                );

                setErrorPolizas("");
                setConsultandoPolizas(false);
                return;
            }

            setConsultandoPolizas(true);
            setErrorPolizas("");

            dispatch(
                setDatosNuevoCompromiso({
                    polizasVigentes: []
                })
            );

            try {

                const ramos = [
                    ...lineasNegocio,
                    ...(ramoConsulta ? [ramoConsulta] : [])
                ];

                const ramosCodigo = [
                    ...new Set(
                        ramos.map((item) => Number(item.rmCodigo))
                    )
                ];

                const ramosNombre = [
                    ...new Set(
                        ramos.map((item) => item.rmDescripcion)
                    )
                ];

                const datos = {tipoIdentificacion,
                        numeroIdentificacion,
                        ramosCodigo,
                        ramosNombre};

                const respuesta = await dispatch(
                    consultarPolizasVigentes(datos)
                );

                if (cancelado) {
                    return;
                }

                if (
                    !respuesta ||
                    respuesta.success === false
                ) {
                    throw new Error(
                        "No fue posible consultar las pólizas vigentes"
                    );
                }

                const polizas =
                    respuesta.data && respuesta.data.polizas
                        ? respuesta.data.polizas
                        : [];

                dispatch(
                    setDatosNuevoCompromiso({
                        polizasVigentes: polizas
                    })
                );

            } catch (error) {

                if (cancelado) {
                    return;
                }

                setErrorPolizas(
                    "No fue posible consultar las pólizas vigentes del cliente."
                );

                dispatch(
                    setDatosNuevoCompromiso({
                        polizasVigentes: []
                    })
                );

            } finally {

                if (!cancelado) {
                    setConsultandoPolizas(false);
                }
            }
        };

        consultar();

        return () => {
            cancelado = true;
        };

    }, [
        dispatch,
        tipoIdentificacion,
        numeroIdentificacion,
        claveRamosConsulta
    ]);

    return (
        <LoadingScreen
            loading={guardarCompromisoLoading}
            bgColor="#f1f1f1"
            spinnerColor="#001871"
            textColor="#676767"
            logoSrc={logo}
            text="Guardando informacion..."
        >
            <CrearCompromisoLayout
                activeStep={2}
                tituloPaso="Datos del Cliente"
            >
                <DatosClienteSection
                    tipoIdentificacion={tipoIdentificacion}
                    numeroIdentificacion={numeroIdentificacion}
                    nombreCompleto={nombreCompleto}
                    emailCliente={emailCliente}
                    telefono={telefono}
                    celular={celular}
                    errores={errores}

                    onNombreChange={(event) =>
                        setNombreCompleto(event.target.value)
                    }

                    onEmailChange={(event) =>
                        setEmailCliente(event.target.value)
                    }

                    onTelefonoChange={(event) =>
                        setTelefono(event.target.value)
                    }

                    onCelularChange={(event) =>
                        setCelular(event.target.value)
                    }
                />
                <LineaNegocioSection
                    lineasSeleccionadas={lineasNegocio}
                    onChange={(nuevasLineas) => {

                        dispatch(
                            setDatosNuevoCompromiso({
                                lineasNegocio: nuevasLineas
                            })
                        );

                        setRamoConsulta(null);

                        if (nuevasLineas.length > 0) {
                            setErrorLineas("");
                        }
                    }}

                    onRamoSeleccionado={(ramo) => {
                        setRamoConsulta(ramo);
                    }}
                    idCompromiso={nuevoCompromiso.idCompromiso}
                    errorExterno={errorLineas}
                />

                <PolizasVigentesSection
                    polizasVigentes={polizasVigentes}
                    loading={consultandoPolizas}
                    error={errorPolizas}
                />
                <div className="compromiso-actions">

                    <Button
                        className="compromiso-button compromiso-button-regresar"
                        onClick={handleAnterior}
                    >
                        <span aria-hidden="true" className="compromiso-button-icon">‹</span>
                        Anterior
                    </Button>

                    <Button
                        className="compromiso-button compromiso-button-consultar"
                        //disabled={!formularioValido()}
                        onClick={handleSiguiente}
                    >
                        Siguiente
                    </Button>


                </div>



            </CrearCompromisoLayout>
            <MessageDialog
                isOpen={mostrarDuplicidad}
                message={mensajeDuplicidad}
                onConfirm={() =>
                    setMostrarDuplicidad(false)
                }
            />
        </LoadingScreen>
    );
};

export default LineasNegocio;